module.exports = __webpack_public_path__ + "static/media/Covid.e3f3be0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/products/Covid.svg
// module id = 86
// module chunks = 0